import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './IssuePage.css'

@CSSModules(Styles, {allowMultiple:true})
export default class IssueFossilFuels extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'The issue: Fossil fuels',
      description: 'Coal, oil, and gas release carbon pollution that accelerates the climate emergency. Rising temperatures will continue to exacerbate the impacts of fires, floods, deadly heatwaves, and other environmental disasters.',
      url: config.domain + config.routes.issueFossilFuels
    }
  }

  render() {
    return (
      <div styleName='page issue-fff'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <section styleName='section'>
            <h1 styleName='issue-top-label'>
              The issue: <span>Fossil fuels</span>
            </h1>
            <h2 styleName='issue-top-headline'>
             Asset managers are investing in the climate crisis
            </h2>
            <h3 styleName='issue-top-copy'>
              Coal, oil, and gas release carbon pollution that accelerates the climate emergency. Rising temperatures will continue to exacerbate the impacts of fires, floods, deadly heatwaves, and other environmental disasters.
            </h3>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={4}>
                <div styleName='issue-second-headline'>
                  <span style={{whiteSpace: 'nowrap'}}>&mdash;&mdash;&mdash;&mdash;</span>
                  <br/>
                  <h2>Retirement plans are still heavily invested in coal, oil, and gas</h2>
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div styleName='issue-second-copy'>
                  <p>
                    As the financial industry looks to align their businesses with the <Link to='https://unfccc.int/process-and-meetings/the-paris-agreement/the-paris-agreement' title='The Paris Agreement - United Nations: Climate Change' xstrong>Paris climate agreement,</Link> asset managers are beginning to exclude some of the most egregious climate offenders, like thermal coal producers, from the funds they offer in corporate retirement plans. However, 401(k)s and similar retirement plans are still mostly invested in index funds with broad exposure to fossil fuel companies – from Big Oil to small fracking companies.
                  </p>
                  <p>
                    Asset managers like Vanguard are investing in a deadly industry – and they’re using workers’ retirement plan savings to do so. Through funds from asset managers like Vanguard, BlackRock, and State Street, the retirement plans of companies like Amazon and Comcast are investing hundreds of billions of dollars into fossil fuel companies that are fueling the climate crisis.
                  </p>
                </div>
              </Col>
            </Row>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={6}>
                <div styleName='img-issue'/>
              </Col>
              <Col xs={12} md={6}>
                <div>
                  <h2 styleName='issue-focus-label'>
                    FOCUS: SUSTAINABILITY RISK
                  </h2>
                  <h3 styleName='issue-focus-headline'>
                    Top carbon reserve owners
                  </h3>
                  <div styleName='issue-focus-copy'>
                    <p>
                      Oil majors and coal mining companies continue to explore for new fossil fuel deposits, despite knowing full well we can only burn a fraction of current proven reserves and still avoid catastrophic climate change.
                    </p>
                    <p>
                      As governments act to restrict emissions, these carbon reserves may become stranded assets, sinking companies and taking people’s savings down with them.
                    </p>
                    <p>
                      <Link
                        to={config.routes.companies + '#fossilfuels'}
                        title='Companies: Fossil fuels'
                        xstrong
                      >
                        Learn more<LinkIcon />
                      </Link>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </ContainerDivs>
        <div styleName='section-solutions-faq-background'>
          <ContainerDivs>
            <section styleName='section section-solutions-faq'>
              <Row>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-solutions-label'>
                      The Solutions
                    </h2>
                    <h3 styleName='issue-solutions-headline'>
                      Exclude climate-harming companies from retirement plan default options
                    </h3>
                    <div styleName='issue-solutions-copy'>
                      <p>
                        The default option offered in company retirement plans, which usually ends up with the bulk of employee contributions, should be sustainably invested and exclude major climate offenders like the <Link to='https://www.ffisolutions.com/research-analytics-index-solutions/research-screening/the-carbon-underground-200/' title='The Carbon Underground 200 - FFI Solutions' xstrong>Carbon Underground 200</Link> and the <Link to='https://coalexit.org/' title='Global Coal Exit List 2020 - Urgewald' xstrong>Global Coal Exit List.</Link>
                      </p>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.solutionDefaultSustainability}
                        title='Solution: Default to sustainability'
                        xstrong
                      >
                        Explore solutions<LinkIcon/>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-faqs-label'>
                      FAQs
                    </h2>
                    <div styleName='issue-faqs-headline'>
                      Answers to common questions about how retirement plans and asset managers are financing the climate crisis.
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-'}
                        title='Do I have to sacrifice returns in order to invest sustainably?'
                        xstrong
                      >
                        Do I have to sacrifice returns in order to invest sustainably?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-'}
                        title='Why should retirement plans add a sustainable investment option?'
                        xstrong
                      >
                        Why should retirement plans add a sustainable investment option?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.faqs}
                        title='FAQs'
                        xstrong
                      >
                      View all >>
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </section>
            <br/>
            <br/>
          </ContainerDivs>
        </div>
      </div>
    )
  }
}
